import { render, staticRenderFns } from "./ProcessFactory.vue?vue&type=template&id=8fc3f954&"
import script from "./ProcessFactory.vue?vue&type=script&lang=js&"
export * from "./ProcessFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports